module.exports = __webpack_public_path__ + "files/SPIADI2026 - Annexe Détection BLC.baebc89764d24224f19f92af6c551c49.pdf";